<script lang="ts">
	//UI
	import {
		Card,
		ProductComposite,
		DefaultButton,
		DefaultSwitch,
	} from "@hitit/new_ui";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	import { createEventDispatcher } from "svelte";
	import { InlineButton, XwithCircle } from "@hitit/new_ui/src";
	import { getKeyInTranslation } from "../../../utils";
	import { onlyNumberHandler } from "@hitit/hub/src/v7/utils";
	//Types
	import type StoreItem from "../../../class/StoreItem/StoreItem";
	//Props
	export let items: StoreItem[];
	//Constants
	const dispatch = createEventDispatcher();
	const mandatoryErrorKey = "global.product.error.mandatory";
	const onlyNumberErrorKey = "global.product.error.only_number";
	const onlyPositiveNumberErrorKey =
		"global.product.error.only_positive_number";
	const onlyIntegerNumberErrorKey = "global.product.error.only_interger_number";
	const deleteButtonHandler = (id?: string) => {
		dispatch("MULTIPLE_SELECTED_ITEM_DELETE", id);
	};
	//Variables
	let price = "";
	let inventory = "";
	let priceError = "";
	let stockError = "";
	let placeEnabled = false;
	//Functions
	function saveClickHandler() {
		const _price = Number(price);
		const _inventory = Number(inventory);
		priceError = isNaN(_price)
			? onlyNumberErrorKey
			: _price < 0
			? onlyPositiveNumberErrorKey
			: !Number.isInteger(_price)
			? onlyIntegerNumberErrorKey
			: price === ""
			? mandatoryErrorKey
			: "";
		stockError =
			inventory !== "" && isNaN(_inventory)
				? onlyNumberErrorKey
				: _inventory < 0
				? onlyPositiveNumberErrorKey
				: !Number.isInteger(_inventory)
				? onlyIntegerNumberErrorKey
				: "";
		if (priceError || stockError) {
			return;
		}

		const newItems = items.map((v) => {
			v.price = _price;
			v.inventory = _inventory;
			v.placeEnabled = placeEnabled;
			return v;
		});

		dispatch("UPDATE_MULTIPLE_ITEMS", newItems);
	}
	function numberHandler(inputName: "price" | "inventory") {
		const callback = (_: HTMLElement, v: string) => {
			if (inputName === "price") price = v;
			else inventory = v;
		};

		return (e: Event) => {
			const target = e.target as HTMLInputElement;
			onlyNumberHandler(target, callback);
		};
	}

</script>

<div class="container" id="multipleviewer-storeitem">
	<Card noPadding>
		<div class="wrapper">
			<div class="input-wrapper">
				<div class="items">
					{#each items as item}
						<div class="item">
							<span
								class="item-name">{getKeyInTranslation(item.getTranslation(), 'name', 'ko') || ''}</span>
							<InlineButton on:click={() => deleteButtonHandler(item.id)}>
								<span class="delete">
									<XwithCircle />
								</span>
							</InlineButton>
						</div>
					{/each}
				</div>
				<ProductComposite
					inputId={'multipleviewer-storeitem-price'}
					inputMode
					numeric
					placeholder={$t('global.require_input')}
					error={priceError !== ''}
					errorMessage={$t(priceError)}
					name={$t('global.product.price')}
					on:input={numberHandler('price')}
					value={price} />
				<ProductComposite
					inputId={'multipleviewer-storeitem-stock'}
					numeric
					inputMode
					error={stockError !== ''}
					errorMessage={$t(stockError)}
					name={$t('global.product.stock')}
					on:input={numberHandler('inventory')}
					value={inventory} />
				<ProductComposite
					numeric
					inputMode
					name={$t('global.product.place_enabled')}
					spaceBetween>
					<div slot="input">
						<DefaultSwitch bind:checked={placeEnabled} />
					</div>
				</ProductComposite>
			</div>
			<div class="button">
				<DefaultButton
					on:click={saveClickHandler}
					fitmode
					id={'multipleviewer-storeitem-save'}>
					<span class="save-button">{$t('global.save')}</span>
				</DefaultButton>
			</div>
		</div>
	</Card>
</div>

<style lang="scss">
	@import "../../../../variables.scss";

	.container {
		display: flex;
		width: 100%;
		flex-direction: column;
	}

	.input-wrapper,
	.wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	.input-wrapper {
		gap: 20px;
	}

	.wrapper {
		padding: 20px 10px;
		gap: 20px;
	}

	.button {
		height: 32px;
	}

	.save-button {
		color: white;
		font-weight: 500;
	}

	.items {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;

		.item {
			display: flex;
			align-items: center;
			gap: 10px;
			padding: 6px 16px;
			background-color: #e6e7ed;
			border-radius: 16px;

			.item-name {
				color: #46474b;
				font-weight: 550;
			}

			.delete {
				width: 20px;
				height: 20px;
			}
		}
	}

	@include DesktopSize {
		.wrapper {
			padding: 30px;
		}

		.save-button {
			font-size: 1.25rem;
		}

		.button {
			height: 40px;
		}
	}

</style>
